import { Location } from "@/interfaces/location";
import { Policy, Service } from "@/interfaces/roles";
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";
import { Component, Prop, Vue } from "vue-property-decorator";
import { NameAppsForm } from "../declarations";
import Template from "./nameApps.template.vue";

@Component({
  mixins: [Template]
})
export default class NameAppsComponent extends Vue {
  @Prop({ required: true }) public value!: NameAppsForm;
  @Prop({ required: true }) public services!: Service[];
  @Prop({ required: true }) public locations!: Location[];
  @Prop({ default: false }) public loading!: boolean;
  @Prop({ default: [] }) public policies!: Policy[];
  public form: boolean = false;
  public image: object = {
    bdi: require("@/assets/images/app_brand_bioTrack.svg"),
    core: require("@/assets/images/app_brand_helix_technologies.svg")
  };

  get model() {
    return cloneDeep(this.value);
  }
  get canContinue() {
    return this.model.selectedServices.length && !this.loading && this.form;
  }

  public next() {
    this.$emit("goToStep", 2);
  }

  public toggleSelected(service: Service) {
    // If service is Core it needs to be added to the head of the array
    if (!this.loading) {
      const index = this.isServiceSelected(service);
      index === -1
        ? service.id === "core"
          ? this.model.selectedServices.unshift(service)
          : this.model.selectedServices.push(service)
        : this.model.selectedServices.splice(index, 1);
      this.updateModel();
    }
  }

  public getButtonLabel(service: Service): string {
    return (this.policies.find(p => p.tag === service.id) || service).name;
  }

  public getServiceId(service: Service): string {
    if (service.id === "bdi") {
      return "btn_biotrack";
    } else {
      return "btn_core";
    }
  }

  public isServiceSelected(service: Service): number {
    return findIndex(this.model.selectedServices, ["id", service.id]);
  }

  public updateModel() {
    this.$emit("input", this.model);
  }

  public requiredRule(value: string) {
    return !!value || this.$t("required_field_err").toString();
  }
}
